export const APP_NAME_CODE = 'dashboard';

export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.nogravity.dashboard';
export const IOS_APP_URL = 'https://apps.apple.com/es/app/no-gravity/id6738140921';
